module.exports = __webpack_public_path__ + "img/pr-2.bc7564a8.png";